import { Divider, Stack, Typography } from "@mui/material";
import { Flex } from "@zfp-akademie-a-s/zfp-design";
import { GoalScale, getLevelSteps } from "Components/Analyses/Questionnaire/QuestionnaireEvaluation";
import type { PortfolioEvaluationWarningItem } from "Infrastructure/ApiZfp/Schema/portfolioEvaluationWarningItem";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatRiskValue } from "./utils";

// the scale of the questionnaire's goal evaluation, its 7 bars without end labels
const RISK_SCALE_STEPS = getLevelSteps("", "");

type Props = {
  readonly riskItem: PortfolioEvaluationWarningItem;
};

export const InvestmentsNsureRiskProfile = ({ riskItem }: Props) => {
  const { t } = useResource();

  const clientRiskProfile = Number.parseFloat(riskItem.clientEvaluationValue ?? "");
  const hasScale = Number.isFinite(clientRiskProfile) && clientRiskProfile > 0;
  const label = t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.Evaluation.RiskProfile);

  return (
    <Stack spacing={Spacing.M}>
      {hasScale ? (
        <GoalScale
          label={label}
          steps={RISK_SCALE_STEPS}
          value={String(Math.min(Math.round(clientRiskProfile), RISK_SCALE_STEPS.length))}
          isValid
        />
      ) : (
        <Typography variant="body2" fontWeight={500}>
          {label}
        </Typography>
      )}

      <Stack divider={<Divider />}>
        <RiskValueRow
          label={t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.Evaluation.RiskClientProfile)}
          value={riskItem.clientEvaluationValue}
        />
        <RiskValueRow label={t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.Evaluation.RiskInvestment)} value={riskItem.toolValue} />
      </Stack>
    </Stack>
  );
};

const RiskValueRow = ({ label, value }: { readonly label: string; readonly value?: string | null }) => (
  <Flex justifyContent="space-between" alignItems="center" gap={Spacing.S} py={Spacing.M}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={700}>
      {formatRiskValue(value)}
    </Typography>
  </Flex>
);
